<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col class="animated fadeIn" cols="12">
        <c-paginate table-uri="paginate/table/categorias" caption="Categorias"  :fields="fields" avatar-key-name="imagenes_id_portadacategoria" new-item-name="Nueva categoria" edit-name="Detalle de categoria"></c-paginate>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import axios from 'axios'
  import _ from 'lodash'

  export default {
    name: 'UsuariosIndex',
    data: () => {
      return {
        fields: [
          {
            key: 'imagenes_id_portadacategoria',
            label: 'Portada'
          },
          {
            key: 'categoria_nombre',
            label: 'Categoria'
          },
          {
            key: 'disponible',
            label: 'Estatus'
          },
          {
            key: '_',
            label: ' '
          }
        ]
      }
    }
  }

</script>
